$('#VerifyEmail').blur(function (event) {
    var email = $('#EmailAdress').val();
    var validationEmail = $('#VerifyEmail').val();
    if (email !== validationEmail) {
        this.setCustomValidity("Email Address do not match");
    }
    else {
        this.setCustomValidity("");
    }
});